import className from '../../../../../home24-shared/components/quickview/constants/classNames-swiper';

const func = e => {
  const newelement = e.target;
  const bigURL = newelement.getAttribute('data-bigpic');
  if (!bigURL) {
    return null;
  }
  $("[data-qvh24-pic-active='true']").attr(
    'class',
    className.SLIDER.INNERWRAP.IMG.STANDARD
  );
  $("[data-qvh24-pic-active='true']").attr('data-qvh24-pic-active', 'false');
  const bigPicture = document.getElementById(`qvh24-bigPic`);
  newelement.className = className.SLIDER.INNERWRAP.IMG.ACTIVE;
  newelement.setAttribute('data-qvh24-pic-active', 'true');
  bigPicture.src = bigURL;
};

const addEventListenerPictures = () => {
  document.querySelector('.swiper-wrapper').addEventListener('mouseover', func);
  document.querySelector('.swiper-wrapper').addEventListener('click', func);
};

export const removeEventlistenerPictures = () => {
  document
    .querySelector('.swiper-wrapper')
    .removeEventListener('mouseover', func);
  document.querySelector('.swiper-wrapper').removeEventListener('click', func);
};

export default addEventListenerPictures;



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/quickview/functions/eventListeners/pictures.js
 **/